import React, { useState } from 'react';
import { Select, Space, Typography } from 'antd';
import BrokerAccounts from './BrokerAccounts';

const { Title, Text } = Typography;

const brokerOptions = [
  { value: 'futu', label: 'FUTU' },
  { value: 'moomoo', label: 'MOOMOO' },
  { value: 'long_port', label: '长桥 LONG_PORT' },
  { value: 'tiger', label: '老虎 TIGER' },
  { value: 'ib', label: 'IB' },
];

const BrokerAccountsManager = () => {
  const [broker, setBroker] = useState('ib');

  return (
    <div>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <div>
          <Title level={4} style={{ marginBottom: 4 }}>券商账户管理</Title>
          <Text type="secondary">选择券商后维护对应账户配置</Text>
        </div>

        <Select
          value={broker}
          onChange={setBroker}
          options={brokerOptions}
          style={{ width: 260 }}
        />

        <BrokerAccounts broker={broker} />
      </Space>
    </div>
  );
};

export default BrokerAccountsManager;
